import styled from "styled-components";
import { Alert } from "@pepdirect/v3/ui/Alert";
import { Device } from "@pepdirect/v3/styles/screenSizes";

export const StyledEmptyCart = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 20px;
`;

export const StyledSpinner = styled.div`
  min-height: 250px; /* allows for spinner to always be completely in view */
  height: 100%;
  /* subtract header height to center spinner when overflowing in mobile */
  @media ${Device.mobile} {
    > div > div {
      margin-top: -60px;
    }
  }
`;
